/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function ($) {
  'use strict';
  
  /**
   * Вид для комментариев Вконтакте
   */
  app.VkCommentView = app.View.extend({
    
    el: '#vk_comments',
    
    beforeRun: function () {
      VK.init({
        apiId: 5024101,
        onlyWidgets: true
      });
    },
    
    run: function () {
      var parentBlockWidth = $('.b-comments').width();
      var settings = {
        limit: 10,
        width: parentBlockWidth,
        attach: false
      };
      var pageUrl = $(this.el).data('pageurl');
      if (pageUrl) {
        settings.pageUrl = pageUrl;
      } else {
        settings.pageUrl = $('link[rel=canonical]').attr('href');
      }
      VK.Widgets.Comments('vk_comments', settings);
    }
    
  });
})(jQuery);

}.call(window));